export default __webpack_public_path__ + "static/media/F0004.efb352a9.png";